<template>
	<div class="new-insert">
		<div class="">
			<el-steps :active="tab" class="steps-wrap">
				<el-step title="個人信息">
					<div class="icon-box" slot="icon" @click="checkTab('Personal', true)">
						<el-image class="insert-icon" v-if="step == 'Personal' || typeVal == 'update'"
							:src="require('@/assets/images/personal-icon.png')"></el-image>
						<el-image class="insert-icon" v-if="step != 'Personal' && typeVal == 'insert'"
							:src="require('@/assets/images/pay-success.png')"></el-image>
					</div>
				</el-step>
				<el-step title="問卷信息" v-if="false">
					<div class="icon-box" slot="icon" @click="checkTab('Questions', true)">
						<el-image v-if="step == 'Questions' || typeVal == 'update'" class="insert-icon"
							:src="require('@/assets/images/quest-int.png')"></el-image>
						<el-image v-if="step == 'Personal' && typeVal == 'insert'" class="insert-icon"
							:src="require('@/assets/images/quest.png')"></el-image>
						<el-image class="insert-icon"
							v-if="(step == 'BiochemicalM22' || step == 'Biochemical'  ||step == 'Bodily') && typeVal == 'insert'"
							:src="require('@/assets/images/pay-success.png')"></el-image>
						<!-- <i class="el-icon-user-solid"></i> -->
					</div>
				</el-step>
				<el-step title="體型信息">
					<div class="icon-box" slot="icon" @click="checkTab('Bodily', true)">
						<el-image v-if="step == 'Bodily' || typeVal == 'update'" class="insert-icon"
							:src="require('@/assets/images/shape-int.png')"></el-image>
						<el-image v-if="(step == 'Personal' || step == 'Questions') && typeVal == 'insert'"
							class="insert-icon" :src="require('@/assets/images/shape.png')"></el-image>
						<el-image class="insert-icon"
							v-if="(step == 'BiochemicalM22' || step == 'Biochemical') && typeVal == 'insert'"
							:src="require('@/assets/images/pay-success.png')"></el-image>
					</div>
				</el-step>
				<el-step title="生化信息" v-if="hasBo">
					<div class="icon-box" slot="icon" @click="checkTab('Biochemical', true)">
						<el-image v-if="step == 'Biochemical' || typeVal == 'update'" class="insert-icon"
							:src="require('@/assets/images/bioch-int.png')"></el-image>
						<el-image
							v-if="(step == 'Personal' || step == 'Questions' || step == 'Bodily') && typeVal == 'insert'"
							class="insert-icon" :src="require('@/assets/images/bioch.png')"></el-image>
					</div>
				</el-step>
				<el-step title="生化信息" v-else-if="isM22">
					<div class="icon-box" slot="icon" @click="checkTab('BiochemicalM22', true)">
						<el-image v-if="step == 'BiochemicalM22' || typeVal == 'update'" class="insert-icon"
							:src="require('@/assets/images/bioch-int.png')"></el-image>
						<el-image
							v-if="(step == 'Personal' || step == 'Questions' || step == 'Bodily') && typeVal == 'insert'"
							class="insert-icon" :src="require('@/assets/images/bioch.png')"></el-image>
					</div>
				</el-step>
			</el-steps>
		</div>
		<router-view :type="typeVal" :is="step" :isBo="isBo" @clearData="clearData" @handleHasBo="handleHasBo"
			@handleIsM22="handleIsM22" :formData="formData" @stopQuery="$emit('stopQuery')"
			@checkTab="checkTab"></router-view>
	</div>
</template>

<script>
	import {
		packageOpen,
		newQuestionsSubmit
	} from '../../js/axios'
	const Personal = () => import('./Personal');
	const Questions = () => import('./Questions');
	const Bodily = () => import('./Bodily');
	const Biochemical = () => import('./Biochemical');
	const BiochemicalM22 = () => import('./BiochemicalM22');

	export default {
		name: 'newInsert',
		data() {
			return {
				tab: 1, //默认从个人信息开始填写
				step: 'Personal',
				formData: {
					examine: [],
					examineObj: {
						WBC: {},
						HGB: {},
						PLT: {},
						FG: {},
						HBA1C: {},
						CHOL: {},
						LDLC: {},
						HDLC: {},
						TG: {},
						UA: {},
					}
				},
				defFormData: {
					examineObj: {
						WBC: {
							"ne": "WBC",
							"ve": "",
							"ut": "A",
						},
						HGB: {
							"ne": "HGB",
							"ve": "",
							"ut": "A",
						},
						PLT: {
							"ne": "PLT",
							"ve": "",
							"ut": "A",
						},
						FG: {
							"ne": "FG",
							"ve": "",
							"ut": "B",
						},
						HBA1C: {
							"ne": "HBA1C",
							"ve": "",
							"ut": "A",
						},
						CHOL: {
							"ne": "CHOL",
							"ve": "",
							"ut": "B",
						},
						LDLC: {
							"ne": "LDLC",
							"ve": "",
							"ut": "B",
						},
						HDLC: {
							"ne": "HDLC",
							"ve": "",
							"ut": "B",
						},
						TG: {
							"ne": "TG",
							"ve": "",
							"ut": "B",
						},
						UA: {
							"ne": "UA",
							"ve": "",
							"ut": "B",
						},
					},
					ord_no: "",
					sex: '',
					birth: '',
					examdate: '',
					package: '',

					height: '',
					weight: '',
					// bust: '',
					waist: '',
					hip: '',
					fat: '',

					area: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [{
							"kdis": "K01",
							"level": "0"
						},
						{
							"kdis": "K02",
							"level": "0"
						},
						{
							"kdis": "K03",
							"level": "0"
						},
						{
							"kdis": "K04",
							"level": "0"
						},
						{
							"kdis": "K05",
							"level": "0"
						},
						{
							"kdis": "K06",
							"level": "0"
						},
						{
							"kdis": "K07",
							"level": "0"
						},
						{
							"kdis": "K08",
							"level": "0"
						},
						{
							"kdis": "K09",
							"level": "0"
						},
						{
							"kdis": "K10",
							"level": "0"
						},
						{
							"kdis": "K11",
							"level": "0"
						},
						{
							"kdis": "K12",
							"level": "0"
						},
						{
							"kdis": "K13",
							"level": "0"
						},
						{
							"kdis": "K14",
							"level": "0"
						},
						{
							"kdis": "K15",
							"level": "0"
						},
						{
							"kdis": "K16",
							"level": "0"
						},
						{
							"kdis": "K17",
							"level": "0"
						},
						{
							"kdis": "K18",
							"level": "0"
						},
						{
							"kdis": "K19",
							"level": "0"
						}
					],
					oper: [],
					famdis: [],

					sbp: '',
					dbp: '',

					examine: [{
							"ne": "WBC",
							"ve": "",
							"ut": "A"
						},
						{
							"ne": "HGB",
							"ve": "",
							"ut": "A"
						},
						{
							"ne": "PLT",
							"ve": "",
							"ut": "A"
						},
						{
							"ne": "FG",
							"ve": "",
							"ut": "B"
						},
						{
							"ne": "HBA1C",
							"ve": "",
							"ut": "A"
						},
						{
							"ne": "CHOL",
							"ve": "",
							"ut": "B"
						},
						{
							"ne": "LDLC",
							"ve": "",
							"ut": "B"
						},
						{
							"ne": "HDLC",
							"ve": "",
							"ut": "B"
						},
						{
							"ne": "TG",
							"ve": "",
							"ut": "B"
						},
						{
							"ne": "GOT",
							"ve": "",
							"ut": "A"
						},
						{
							"ne": "GPT",
							"ve": "",
							"ut": "A"
						},
						{
							"ne": "ALP",
							"ve": "",
							"ut": "A"
						},
						{
							"ne": "ALB",
							"ve": "",
							"ut": "B"
						},
						{
							"ne": "CRE",
							"ve": "",
							"ut": "B"
						},
						{
							"ne": "UA",
							"ve": "",
							"ut": "B"
						},
						{
							"ne": "EGFR",
							"ve": "",
							"ut": "A"
						}
					],


				},
				examineList: [{
						"ne": "WBC",
						"ve": "",
						"ut": "A",
						"name": "白細胞(WBC)"
					},
					{
						"ne": "HGB",
						"ve": "",
						"ut": "A",
						"name": "血紅蛋白(HGB)"
					},
					{
						"ne": "PLT",
						"ve": "",
						"ut": "A",
						"name": "血小板(PLT)"
					},
					{
						"ne": "FG",
						"ve": "",
						"ut": "B",
						"name": "空腹血糖(FG)"
					},
					{
						"ne": "HBA1C",
						"ve": "",
						"ut": "A",
						"name": "糖化血紅蛋白(HBA1C)"
					},
					{
						"ne": "CHOL",
						"ve": "",
						"ut": "B",
						"name": "總膽固醇(CHOL)"
					},
					{
						"ne": "LDLC",
						"ve": "",
						"ut": "B",
						"name": "低密度脂蛋白(LDLC)"
					},
					{
						"ne": "HDLC",
						"ve": "",
						"ut": "B",
						"name": "高密度脂蛋白(HDLC)"
					},
					{
						"ne": "TG",
						"ve": "",
						"ut": "B",
						"name": "甘油三酯(TG)"
					},
					{
						"ne": "UA",
						"ve": "",
						"ut": "B",
						"name": "尿酸(UA)"
					},
				],
				hasBo: false,
				isM22: true,
				typeVal: 'insert'
			}
		},
		components: {
			// Tabs,
			Personal,
			Questions,
			Bodily,
			Biochemical,
			BiochemicalM22
		},
		props: ['type', 'dataId', 'isBo', 'reportCode'],
		mounted() {
			this.formData = this.defFormData;
			let report_id = sessionStorage.getItem('report_id') ? sessionStorage.getItem('report_id') : '';
			if (report_id) {
				newQuestionsSubmit({
					id: report_id,
					act: 'query'
				}).then((res) => {
					if (res.code == 200) {
						let result = JSON.parse(window.atob(res.data))
						this.formData = result.input_data;
						console.log("之前的表单：",this.formData);
						this.formData.waist = result.input_data.waist ? result.input_data.waist : ""
						this.formData.hip = result.input_data.hip ? result.input_data.hip : ""
						this.formData.id = result.id;
						const examineObj = Object.fromEntries(result.input_data.examine.map(item => [item.ne,
							item]))
						this.formData.examineObj = examineObj
						this.typeVal = 'update'
						if (this.formData.type == 'M22') {
							this.tab = 5
						} else {
							this.tab = 4
						}
					}
				})
			}
		},
		watch: {

		},
		methods: {
			handleHasBo(hasBo) {
				this.hasBo = hasBo
			},
			handleIsM22(isM22) {
				this.isM22 = isM22
			},
			//切换tab 参数 tab组件名
			checkTab(tab, isTab) {
				if (this.typeVal == 'insert' && isTab) {
					return;
				}
				if (this.typeVal == 'update') {
					if (this.formData.type == 'M22') {
						this.tab = 3
					} else {
						this.tab = 4
					}
					this.step = tab
					return
				}
				switch (tab) {
					case 'Personal':
						this.tab = 1
						break
					case 'Questions':
						this.tab = 2
						break
					case 'Bodily':
						this.tab = this.formData.type == 'M22' ? 2 : 3
						break
					case 'Biochemical':
						this.tab = 4
						break
					case 'BiochemicalM22':
						this.tab = 5
						break
				}
				this.step = tab
			},
			clearData(data) {
				this.formData = this.defFormData
			},
		}
	}
</script>

<style scoped>
	.new-insert>>>.el-step__icon {
		width: 36px;
		height: 36px;
		background-color: #F2F4FA;
		border-radius: 50%;
		cursor: pointer;
	}

	.new-insert>>>.el-step__icon.is-text {
		border: none;
	}

	.new-insert>>>.el-step.is-horizontal .el-step__line {
		height: 6px;
		top: 16px;
		background-color: #F2F4FA;
	}

	.new-insert>>>.el-step__line-inner {
		height: 6px;
		top: 16px;
		background: #6883FB;
	}

	.new-insert>>>.el-step__title {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		line-height: 16px;
	}

	.new-insert>>>.el-step__main {
		position: relative;
		left: -6px;
		margin-top: 8px;
	}
</style>

<style lang="scss" scoped>
	.steps-wrap {
		width: 752px;
		margin: 16px auto 0;
	}

	.icon-box {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		// background-color: #6883FB;
		border-radius: 50%;
	}

	.el-icon-user-solid {
		font-size: 20px;
		color: #fff;
	}

	.insert-icon {
		width: 36px;
		height: 36px;
	}
</style>